<template>
  <div>
    <v-app-bar
      app
      elevation="0"
      color="white"
      height="80"
      class="px-4"
    >
      <v-container>
        <v-row align="center" class="ma-0">
          <v-col cols="auto" class="d-flex align-center pa-0">
            <v-icon size="48" class="logo-header">$logoAdaptify</v-icon>
            <span class="text-h5 primary--text pl-3 font-weight-bold brand">{{ brandText }}</span>
          </v-col>

          <v-spacer></v-spacer>

          <v-col cols="auto" class="d-none d-lg-flex pa-0">
            <v-btn
              v-for="item in currentItems"
              :key="item.label"
              :text="!item.cta"
              :depressed="item.cta"
              :color="item.cta ? 'secondary' : 'greydark'"
              :class="item.cta ? 'ml-4 white--text' : 'mx-2'"
              :rounded="item.cta"
              :to="item.to || undefined"
              :href="item.href || undefined"
            >
              {{ item.label }}
            </v-btn>
          </v-col>

          <v-app-bar-nav-icon class="d-lg-none" @click="drawer = !drawer" aria-label="Abrir menú"></v-app-bar-nav-icon>
        </v-row>
      </v-container>
    </v-app-bar>

    <v-navigation-drawer
      v-model="drawer"
      app
      temporary
      right
    >
      <v-list>
        <v-list-item
          v-for="item in currentItems"
          :key="item.label"
          :to="item.to || undefined"
          :href="item.href || undefined"
          @click="drawer = false"
        >
          <v-list-item-content>
            <v-list-item-title
              :class="item.cta ? 'secondary--text font-weight-bold' : ''"
            >{{ item.label }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
  </div>
</template>

<script>
export default {
  name: 'SiteHeader',
  props: {
    vertical: {
      type: String,
      default: 'hub',
      validator: (v) => ['hub', 'tradeflow'].includes(v),
    },
  },
  data() {
    return {
      drawer: false,
    };
  },
  computed: {
    navItems() {
      return {
        hub: [
          {
            label: 'TradeFlow', to: '/tradeflow', href: null, cta: false,
          },
          {
            label: 'Contacto', to: null, href: '#contact', cta: true,
          },
        ],
        tradeflow: [
          {
            label: 'AdaptifyX', to: '/', href: null, cta: false,
          },
          {
            label: 'Problema', to: null, href: '#tf-problem', cta: false,
          },
          {
            label: 'Solución', to: null, href: '#tf-solution', cta: false,
          },
          {
            label: 'Precio', to: null, href: '#tf-pricing', cta: false,
          },
          {
            label: 'Casos', to: null, href: '#tf-cases', cta: false,
          },
          {
            label: 'FAQ', to: null, href: '#tf-faq', cta: false,
          },
          {
            label: 'Empezar Ahora',
            to: null,
            href: '#tf-contact',
            cta: true,
          },
        ],
      };
    },
    currentItems() {
      return this.navItems[this.vertical] || this.navItems.hub;
    },
    brandText() {
      return this.vertical === 'tradeflow' ? 'TradeFlow' : 'AdaptifyX';
    },
  },
};
</script>

<style lang="scss">
.logo-header > svg {
  fill: var(--v-primary-base);
}
</style>
